import { graphql } from '@graphql/__generated'

export const GET_EVENT_PORTAL_BY_ID = graphql(`
  query getEventPortalById($input: GetEventByIdInput!) {
    getEventById(input: $input) {
      ...EventPortal
    }
  }
`)
